export default __webpack_public_path__ + "static/media/GA.70dbf886.svg";